// Track errors already handled by redirecting to login or client selection.
const handledErrors = new WeakSet<object>()

export const markHandledSessionError = (error: object) => {
  handledErrors.add(error)
}

export const isHandledSessionError = (error: unknown): boolean => {
  if (!error || typeof error !== 'object') return false
  if (handledErrors.has(error)) return true

  const apolloError = error as {
    networkError?: object
    graphQLErrors?: object[]
    clientErrors?: unknown[]
  }

  // Preserve reports that also contain independent network, GraphQL or client errors.
  if (apolloError.clientErrors?.length) {
    return false
  }

  const errors = [...(apolloError.graphQLErrors ?? [])]
  if (apolloError.networkError) errors.push(apolloError.networkError)

  return errors.length > 0 && errors.every(err => handledErrors.has(err))
}
